import { Action } from 'common/interfaces/root';
import { overviewActionTypes as T } from '../actions';

const initState: Overview.StatisticsStore = {
  loading: true,
  error: null,
  entries: null,
};

export default (state: Overview.StatisticsStore = initState, { type, payload }: Action): Overview.StatisticsStore => {
  switch (type) {
    case T.GET_ALL_STATISTICS:
      return { ...state, loading: true };

    case T.GET_ALL_STATISTICS_SUCCESS:
      return { ...state, loading: false, entries: payload };

    case T.GET_ALL_STATISTICS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
